function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import $ from 'jquery';
import { utils } from '../utils';
import { translationUtils, Consts } from '@wix/photography-client-lib';
import FULLSCREEN_EVENTS from '../constants/fullscreenEvents';
import { isSEOMode } from '../utils/viewModeWrapper';

var FullscreenSidebar = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FullscreenSidebar, _React$Component);

  function FullscreenSidebar(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isSmallScreen: utils.isSmallScreen(),
      isMobile: utils.isMobile(),
      isReadMoreVisible: false,
      isReadMoreOpen: false
    };
    return _this;
  }

  var _proto = FullscreenSidebar.prototype;

  _proto.fixTextsLineHeight = function fixTextsLineHeight(isReadMoreOpen) {
    var elem = this.itemContainer;
    var title = $(elem).find('.fullscreen-side-bar-title');
    var description = $(elem).find('.fullscreen-side-bar-description');
    var availableHeight = 150;
    var numberOfLinesRequired = 3;
    var spaceBetweenTitleAndDescription = 0;
    var originalTitleHeight = 0;
    var originalDescriptionHeight = 0;
    var titleLineHeight = parseInt(title.css('line-height')) || 0;
    var numOfTitleLines = 0;
    var numOfDescriptionLines = 0; // reset truncation stuff

    title.css({
      height: 'initial'
    });
    description.css({
      height: 'initial'
    });
    title.css({
      '-webkit-line-clamp': 'initial'
    });
    description.css({
      '-webkit-line-clamp': 'initial'
    });

    if (title && title[0]) {
      // originalTitleHeight = title[0].scrollHeight - 18 //substructing the title margin-bottom
      originalTitleHeight = title[0].scrollHeight;
    }

    if (description && description[0]) {
      // originalDescriptionHeight = description[0].scrollHeight - 24 //substructing the description margin-bottom
      originalDescriptionHeight = description[0].scrollHeight;
    }

    if (!isReadMoreOpen) {
      var titleText = utils.getTitleOrFilename(this.props.current.item.title, this.props.fileName);

      if (this.props.styles.allowTitleExpand && titleText) {
        if (title && title.length !== 1) {
          return;
        }

        spaceBetweenTitleAndDescription = 30;
        numOfTitleLines = this.truncateElement(availableHeight, numberOfLinesRequired, title, originalTitleHeight);
        var titleHeight = numOfTitleLines * titleLineHeight;

        if (availableHeight > titleHeight) {
          availableHeight -= titleHeight;
        } else {
          availableHeight = 0;
        }
      }

      if (this.props.styles.allowDescriptionExpand && this.props.current.item.description) {
        if (description && description.length !== 1) {
          return;
        }

        availableHeight -= spaceBetweenTitleAndDescription;

        if (availableHeight <= 0) {
          description.hide();
          return;
        }

        numOfDescriptionLines = this.truncateElement(availableHeight, numberOfLinesRequired - numOfTitleLines, description, originalDescriptionHeight);

        if (numOfDescriptionLines === 0) {
          description.hide();
        }
      }
    } else {
      //all the title and description should be displayed
      if (this.props.current.item.isReadMoreOpen) {
        this.setState({
          isReadMoreVisible: true
        });
      }

      title.css({
        height: originalTitleHeight
      });
      description.css({
        height: originalDescriptionHeight
      });
      description.show();
      title.css({
        '-webkit-line-clamp': 'initial'
      });
      description.css({
        '-webkit-line-clamp': 'initial'
      });
    }
  };

  _proto.truncateElement = function truncateElement(availableHeight, numberOfLinesRequired, element, originalElementHeight) {
    var numOfElementLines = 0;
    element.css({
      overflow: 'visible'
    });
    var elementHeight = originalElementHeight;
    var elementLineHeight = parseInt(element.css('line-height')) || 0;
    var originalNumberOfElementLines = Math.floor(elementHeight / elementLineHeight);
    numOfElementLines = Math.min(Math.floor(availableHeight / elementLineHeight), numberOfLinesRequired, originalNumberOfElementLines);

    if (numOfElementLines < originalNumberOfElementLines) {
      //need to truncate the element
      this.props.current.item.isReadMoreOpen = false;
      this.setState({
        isReadMoreOpen: false
      });
      this.setState({
        isReadMoreVisible: true
      });
      element.css({
        '-webkit-line-clamp': numOfElementLines + ''
      });
      elementHeight = elementLineHeight * numOfElementLines;
      element.css({
        overflow: 'hidden',
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        height: elementHeight
      });
    } else {
      //all the element can be displayed
      if (this.props.current.item.isReadMoreOpen) {
        this.setState({
          isReadMoreVisible: true
        });
      }

      element.css({
        '-webkit-line-clamp': 'initial'
      });
      elementHeight = elementLineHeight * originalNumberOfElementLines;
    }

    return numOfElementLines;
  };

  _proto.toggleReadMore = function toggleReadMore() {
    this.props.current.item.isReadMoreOpen = !this.props.current.item.isReadMoreOpen;
    this.setState({
      isReadMoreOpen: this.props.current.item.isReadMoreOpen
    });
    this.fixTextsLineHeight(this.curItem.isReadMoreOpen);
  };

  _proto.isVisible = function isVisible() {
    // Note: There are 2 props that are responsible for showing the sidebar: 'showInfo' and 'shouldShowInfo' - probably historic reasons..
    return (this.props.showInfo || this.props.shouldShowInfo) && (this.props.current.hasInfo || this.props.customSidebarRenderer) || this.props.isAdditionalMobileSidebarOpened === true;
  };

  _proto.getAdditionalSidebarElement = function getAdditionalSidebarElement() {
    var additionalSidebarElement = this.props.additionalSidebarElement;

    try {
      if (additionalSidebarElement) {
        return additionalSidebarElement(_objectSpread(_objectSpread({}, this.props), {}, {
          styleParams: this.props.styles
        }));
      } else {
        return false;
      }
    } catch (e) {
      console.error('Could not get additional sidebar element', e);
    }
  };

  _proto.hasAdditionalSidebarElement = function hasAdditionalSidebarElement() {
    if (utils.isMobile()) {
      var customMobileSidebarRenderer = this.props.customMobileSidebarRenderer;
      return typeof customMobileSidebarRenderer === 'function';
    } else {
      var additionalSidebarElement = this.props.additionalSidebarElement;
      return typeof additionalSidebarElement === 'function';
    }
  };

  _proto.onKeyPress = function onKeyPress(e, onClickFunction) {
    switch (e.keyCode || e.charCode) {
      case 32: //space

      case 13:
        //enter
        e.preventDefault();
        onClickFunction();
        return false;
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.hasAdditionalSidebarElement()) {
      if (prevProps.current.item.id !== this.props.current.item.id) {
        // we are dealing with a new item
        if (this.state.isReadMoreVisible) {
          this.setState({
            isReadMoreVisible: false
          });
        }

        this.setState({
          isReadMoreOpen: this.props.current.item.isReadMoreOpen
        });
        this.fixTextsLineHeight(this.curItem.isReadMoreOpen);
      }
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.hasAdditionalSidebarElement()) {
      this.fixTextsLineHeight(this.curItem.isReadMoreOpen);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var curItem = this.curItem = this.props.current.item;
    var _this$state = this.state,
        isReadMoreVisible = _this$state.isReadMoreVisible,
        isSmallScreen = _this$state.isSmallScreen,
        isMobile = _this$state.isMobile,
        isReadMoreOpen = _this$state.isReadMoreOpen;
    var hasAdditionalSidebarElement = this.hasAdditionalSidebarElement();
    var isStoreMobile = hasAdditionalSidebarElement && isMobile;
    var titleText = utils.getTitleOrFilename(curItem.title, curItem.fileName) || ''; //(curItem.isDemo ? curItem.demoTitle : ''); - remove default text from demo items until rewritten

    var title = titleText && this.props.styles.allowTitleExpand && !isStoreMobile ? /*#__PURE__*/React.createElement("div", {
      className: "fullscreen-side-bar-title",
      tabIndex: -1 //aria-label={titleText}

    }, titleText) : null;
    var descriptionText = curItem.description || '';
    var description;

    if (descriptionText && this.props.styles.allowDescriptionExpand && !isStoreMobile) {
      var descriptionClassName = 'fullscreen-side-bar-description';
      descriptionClassName += hasAdditionalSidebarElement ? ' pro-fullscreen-store' : '';
      description = /*#__PURE__*/React.createElement("div", {
        className: descriptionClassName,
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("div", {
        className: "fullscreen-side-bar-description-line",
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, descriptionText));
    } else {
      description = null;
    }

    var prettyExif = '';

    if (curItem.exif) {
      var camera = curItem.exif.Model; //todo - place separators using join

      var focalLength = curItem.exif.FocalLength ? /*#__PURE__*/React.createElement("span", null, curItem.exif.FocalLength, "mm") : '';
      var fNumber = curItem.exif.FNumber ? /*#__PURE__*/React.createElement("span", null, "\xA0\xA0/\xA0\xA0\u0192/", curItem.exif.FNumber) : '';
      var roundExposureTime = Math.round(1 / Number(curItem.exif.ExposureTime));
      var exposureTime = roundExposureTime > 0 ? /*#__PURE__*/React.createElement("span", null, "\xA0\xA0/\xA0\xA01/", roundExposureTime, "s") : '';
      var isoSpeed = curItem.exif.IsoSpeed ? /*#__PURE__*/React.createElement("span", null, "\xA0\xA0/\xA0\xA0ISO ", curItem.exif.IsoSpeed) : '';
      var showExif = focalLength || fNumber || exposureTime || isoSpeed;
      prettyExif = showExif && this.props.styles.allowExifExpand && !hasAdditionalSidebarElement ? /*#__PURE__*/React.createElement("div", {
        className: "fullscreen-side-bar-exif"
      }, /*#__PURE__*/React.createElement("div", {
        className: "exif-camera"
      }, camera), /*#__PURE__*/React.createElement("div", {
        className: "exif-shot"
      }, focalLength, fNumber, exposureTime, isoSpeed)) : '';
    }
    /*
     var allExif = [];
     for (var field in curItem.exif) {
     if (curItem.exif.hasOwnProperty(field)) {
     allExif.push(
     <p>{field}: {curItem.exif[field]}</p>
     )
     }
     }
      <p className="exif-more">see all</p>
     <div className="exif-all">
     {allExif}
     </div>
     */


    var linkClassNames = 'fullscreen-side-bar-link pro-fullscreen-link';
    linkClassNames += hasAdditionalSidebarElement ? ' pro-fullscreen-store' : '';
    var isSEO = isSEOMode();
    var noFollowForSEO = this.props.noFollowForSEO;
    var shouldUseNofollow = isSEO && noFollowForSEO;
    var seoLinkParams = shouldUseNofollow ? {
      rel: 'nofollow'
    } : {};
    var link = curItem.hasLink && this.props.styles.allowLinkExpand && !isStoreMobile && (hasAdditionalSidebarElement ? curItem.hasLink && (!isReadMoreVisible || isReadMoreOpen) : true) ? curItem.linkType === 'web' ? /*#__PURE__*/React.createElement("a", _extends({
      className: linkClassNames,
      href: !curItem.isWixUrl && curItem.linkUrl,
      onClick: function onClick() {
        return curItem.isWixUrl && _this2.props.actions.eventsListener(FULLSCREEN_EVENTS.NAVIGATE, curItem);
      },
      onKeyDown: function onKeyDown(e) {
        return _this2.onKeyPress(e, function () {
          return curItem.isWixUrl && _this2.props.actions.eventsListener(FULLSCREEN_EVENTS.NAVIGATE, curItem);
        });
      },
      target: curItem.linkOpenType,
      tabIndex: this.isVisible() ? utils.getTabIndex('fullscreenLink') : -1,
      "aria-label": curItem.linkText
    }, seoLinkParams), curItem.linkText || curItem.linkUrl) : /*#__PURE__*/React.createElement("a", {
      className: linkClassNames,
      onClick: function onClick() {
        return _this2.props.actions.eventsListener(FULLSCREEN_EVENTS.NAVIGATE, curItem);
      },
      onKeyDown: function onKeyDown(e) {
        return _this2.onKeyPress(e, function () {
          return _this2.props.actions.eventsListener(FULLSCREEN_EVENTS.NAVIGATE, curItem);
        });
      },
      tabIndex: this.isVisible() ? utils.getTabIndex('fullscreenLink') : -1,
      "aria-label": curItem.linkText
    }, curItem.linkText || curItem.linkUrl) : '';
    var readLess = translationUtils ? translationUtils.getByKey('Gallery_Read_Less') : 'read_less';
    var readMore = translationUtils ? translationUtils.getByKey('Gallery_Read_More') : 'read_more';
    var readMoreText = isReadMoreOpen ? readLess : readMore;
    var readMoreOrLess = isReadMoreVisible ? /*#__PURE__*/React.createElement("div", {
      className: "pro-fullscreen-read-more fullscreen-side-bar-description",
      onClick: function onClick() {
        return _this2.toggleReadMore();
      }
    }, readMoreText) : null;
    var infoContainerClassName = 'fullscreen-side-bar-info-container';
    infoContainerClassName += hasAdditionalSidebarElement ? ' pro-fullscreen-store' : ''; // infoContainerClassName += (isSmallScreen ? '' : ' mCustomScrollbar pro-fullscreen-custom-scroller');

    infoContainerClassName += hasAdditionalSidebarElement ? isSmallScreen ? '' : ' pro-fullscreen-custom-scroller' : '';
    var isBottomInfo = this.props.styles.expandInfoPosition === Consts.expandInfoPositions.BOTTOM;
    var isSidebarOpened = this.isVisible() || !this.props.currentWindow.expanded && hasAdditionalSidebarElement && !this.state.isMobile;
    var infoContainerStyle = isBottomInfo && !isMobile ? {
      maxHeight: 200,
      overflowY: 'auto'
    } : {};
    var limitBottomInfo = isBottomInfo && !isMobile ? {
      width: '700px',
      left: 'calc(50% - 350px)'
    } : {};

    var style = _objectSpread({
      textAlign: this.props.styles.galleryAlignExpand,
      transform: "scale(" + (isSidebarOpened ? 1 : 0) + ")"
    }, limitBottomInfo);

    if (this.props.customSidebarRenderer) {
      return /*#__PURE__*/React.createElement("div", {
        className: 'fullscreen-side-bar' + (isBottomInfo ? '-bottom' : '') + (isSidebarOpened ? ' pro-fullscreen-opened' : ' pro-fullscreen-closed') + (isSmallScreen ? ' pro-fullscreen-mobile' : ''),
        style: style,
        dir: 'auto',
        "aria-hidden": !isSidebarOpened
      }, this.props.customSidebarRenderer(_objectSpread(_objectSpread({}, this.props), {}, {
        styleParams: this.props.styles
      })));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: 'fullscreen-side-bar' + (isBottomInfo ? '-bottom' : '') + (isSidebarOpened ? ' pro-fullscreen-opened' : ' pro-fullscreen-closed') + (isSmallScreen ? ' pro-fullscreen-mobile' : '') + (hasAdditionalSidebarElement ? ' pro-fullscreen-store' : ''),
        style: style,
        dir: 'auto',
        "aria-hidden": !isSidebarOpened
      }, /*#__PURE__*/React.createElement("div", {
        className: infoContainerClassName,
        style: infoContainerStyle
      }, /*#__PURE__*/React.createElement("div", {
        ref: function ref(itemContainer) {
          _this2.itemContainer = itemContainer;
        }
      }, title, description), prettyExif, link, readMoreOrLess, this.getAdditionalSidebarElement()));
    }
  };

  return FullscreenSidebar;
}(React.Component);

export default FullscreenSidebar;